import router from '@/router/index.js';
import { start, stop } from './client.js';
import { registerVitals } from './vitals.js';
import { registerNavTracking, stopNavTracking } from './nav.js';
import { registerErrorTracking, stopErrorTracking } from './errors.js';
import { registerInteractions, stopInteractions } from './interactions.js';
import { track } from './track.js';

export default {
  install(app) {
    // registerPlugins() runs BEFORE app.mount(), so an unguarded throw here would
    // white-screen the app. Telemetry must never break boot — swallow any failure.
    try {
      registerErrorTracking(app);
      registerNavTracking(router);
      // registerVitals BEFORE start(): web-vitals registers its own
      // visibilitychange/pagehide listeners on call, and listeners fire in
      // registration order — so a late CLS/LCP/INP value is buffered by emit()
      // before the client's final flush runs. Reordering risks dropping the last vital.
      registerVitals();
      registerInteractions();
      start();
      app.config.globalProperties.$track = track;
      window.$track = track; // for plain-JS callers (composables/utils)
    } catch {
      /* a dead telemetry layer is acceptable; a dead app is not */
    }
  },
};

// Dev-only: tear down listeners on HMR so hot-reloads don't accumulate duplicate
// click/nav/error listeners (and duplicate emits). web-vitals reporters have no
// off API, so vital reporters may still duplicate across HMR — harmless, dev-only.
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    try {
      stop();
      stopNavTracking();
      stopInteractions();
      stopErrorTracking();
    } catch {
      /* noop */
    }
  });
}
